 import { createApiClient } from 'Network/ApiClient';
  
  export const IcdNotAllowedIcdAxiosInstance = createApiClient('diagnoses/');


